import i18n from "@microdoing/shared/i18n";
import { Box, Loading, MainText } from "app/components/common";
import React from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";

const HEADER_HEIGHT = 50;

interface Props {}

const LoadMore = ({}: Props) => {
  const insets = useSafeAreaInsets();

  return (
    <Box
      position="absolute"
      justifyContent="center"
      alignItems="center"
      left={0}
      right={0}
      style={{ top: HEADER_HEIGHT + 5 + insets.top }}
    >
      <MainText variant="l3-medium" marginBottom="s" color="neutral.500">
        {i18n.t("loading-messages")}
      </MainText>
      <Loading size={30} />
    </Box>
  );
};

export default LoadMore;
